import type { Environment } from '@/core/lib/env/env.context';
import { ACTUAL_ENV, valuesFromProcess } from '@/core/lib/env/env.context';
import { ApiVersions } from '@/core/lib/fetch';
import api from '@/core/lib/fetch/api';
import type { BadgesResult } from '@/core/types/badge';
import { badgesResultSchema } from '@/core/types/badge';

const getUrl = () => valuesFromProcess[ACTUAL_ENV as Environment]?.DONNONS_API_URL;

const query = {
  get: async () =>
    api.get<BadgesResult>({
      url: `${getUrl()}${ApiVersions.V1}/badges`,
      schema: badgesResultSchema,
    }),
};

export default { query };
